import { render, staticRenderFns } from "./identity.vue?vue&type=template&id=d4058864&scoped=true&"
import script from "./identity.vue?vue&type=script&lang=ts&"
export * from "./identity.vue?vue&type=script&lang=ts&"
import style0 from "./identity.vue?vue&type=style&index=0&id=d4058864&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4058864",
  null
  
)

export default component.exports